export const storyTemplatesPageMessages = {
  title: 'Story Templates',
  subtitle:
    'Manage story templates or choose a story template to create a story ',
  createButton: 'Create Template',
  loading: 'Loading story templates...',
  errorLoading: 'Failed to load story templates',
  noTemplatesFound: 'No story templates found',
  noTemplatesDescription: 'Check back later for new story templates',
  createStoryAction: 'Create Story',
  openPreviewAction: 'Open Preview',
  deleteAction: 'Delete Template',
  deleteConfirmTitle: 'Delete Story Template',
  deleteConfirmMessage:
    'Are you sure you want to delete this story template? This action cannot be undone.',
  deleteSuccessMessage: 'Story template deleted successfully',
  deleteErrorMessage: 'Failed to delete story template',
  deleting: 'Deleting...',

  // Entity card labels
  ageRangeLabel: 'Age Range',
  themesLabel: 'Themes',
  rolesLabel: 'Roles',

  // Custom template card
  customTemplateCardTitle: 'Make your own story!',
  customTemplateCardDescription:
    'Customize title, plot, and characters to tell your own personal story!',
  customTemplateCardAction: 'Create Story',
} as const;
